import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import u1 from "../../../Assets/images/authBg.png";
import { Link, useNavigate } from "react-router-dom";
import { CstmPagination } from "../../../components/Common/Common";
import { DELETE_INQUIRY, HELPANDSUPPORTAPI } from "../../../services/ApiCalls";
import Filter from "../../../components/Common/Filter";
import {
  defaultDeleteModelState,
  statusOptions
} from "../../../utilities/const";
import CustomPagination from "../../../components/Common/CustomPagination";
import dataHandler from "../../../hooks/dataHandler";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import TableActions from "../../../components/Common/TableActions";
import { useTranslation } from "react-i18next";

const Help = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: HELPANDSUPPORTAPI,
  });

  const column = [
    {
      head: t("help.srNo"),
      accessor: "#",
      component: (item, key) => <>{body.limit * (body.page - 1) + key + 1}</>,
    },
    {
      head: t("help.name"),
      accessor: "fname",
      component: (item) => {
        const firstName = item?.raisedBy?.first_name || "";
        const lastName = item?.raisedBy?.last_name || "";
        const fullName = [firstName, lastName].filter(Boolean).join(" ");
        return <>{fullName || "-"}</>;
      },
    },
    {
      head: t("help.category"),
      accessor: "category",
      component: (item) => <>{item?.category}</>,
    },
    {
      head: t("help.email"),
      accessor: "email",
      component: (item) => (
        <span className="d-block text-truncate">
          {item?.raisedBy?.email}
        </span>
      ),
    },
    {
      head: t("help.phoneNumber"),
      accessor: "mobileNumber",
      component: (item) => <>{item?.raisedBy?.mobileNumber}</>,
    },
    {
      head: t("help.subject"),
      accessor: "subject",
      component: (item) => <>{item?.subject}</>,
    },
    {
      head: t("help.role"),
      accessor: "role",
      component: (item) => (
        <span className="d-flex text-capitalize">{item?.role}</span>
      ),
    },
    {
      head: t("common.status"),
      accessor: "status",
      component: (item) => (
        <p
          className={`status px-2 rounded-pill px-0 m-0 text-capitalize py-1 text-center ${
            item.status === "open"
              ? "yellowLabel"
              : item.status === "close"
              ? "greenLabel"
              : item.status === "inprogress" || item.status === "In Progress"
              ? "blueLabel"
              : ""
          }`}
        >
          {t(`help.status.${item.status}`)}
        </p>
      ),
    },
    {
      head: t("common.action"),
      accessor: "Action",
      component: (item) => (
        <TableActions viewLink={`/help/detail/${item?._id}`} />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel(() => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => DELETE_INQUIRY({ _id: deleteModel.dumpId }))
        }
        type={"delete"}
      />

      <section className="help position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                {t("help.title")}
              </h4>
            </Col>

            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={statusOptions}
                  />
                </div>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                body={body}
                pageChangeHandler={paginationHandler}
                setBody={setBody}
                total={total}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Help;
